import { render, staticRenderFns } from "./scrollTop.vue?vue&type=template&id=c60965be&scoped=true&"
import script from "./scrollTop.vue?vue&type=script&lang=js&"
export * from "./scrollTop.vue?vue&type=script&lang=js&"
import style0 from "./scrollTop.vue?vue&type=style&index=0&id=c60965be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60965be",
  null
  
)

export default component.exports